import { ModuleType } from 'infrastructure/enums';

export const isAdminModule = (module: ModuleType) =>
  module === ModuleType.ADMIN;
export const isCcmModule = (module: ModuleType) => module === ModuleType.CCM;
export const isRpmModule = (module: ModuleType) => module === ModuleType.RPM;
